export default __webpack_public_path__ + "static/media/dropdown-arrow-up.cfa959a6.svg";